import actionTypes from "../types";

const {
  GET_SHORTLISTED,
  GET_SHORTLISTED_SUCCESS,
  GET_SHORTLISTED_ERROR,
  UPDATE_SHORTLISTED,
  ADD_TO_SHORTLISTED,
  UPDATE_SHORTLISTED_SUCCESS,
  UPDATE_SHORTLISTED_ERROR,
  REMOVE_SHORTLISTED,
  REMOVE_SHORTLISTED_SUCCESS,
  SEND_INVITE,
  SEND_INVITE_SUCCESS,
  SEND_INVITE_ERROR,
  GET_ROLE_DATA,
  GET_ROLE_DATA_SUCCESS,
  GET_ROLE_DATA_ERROR,
  GENERATE_TIERS,
  GENERATE_TIERS_SUCCESS,
  GENERATE_TIERS_ERROR,
  TIERS_JOB,
  TIERS_JOB_UPDATING,
  TIERS_JOB_SUCCESS,
  TIERS_JOB_ERROR,
  TIERS_JOB_CANCEL,
  CONFIRM_TEMPLATE,
  CONFIRM_TEMPLATE_SUCCESS,
  CONFIRM_TEMPLATE_ERROR,
  BACKUP_TEMPLATE,
  BACKUP_TEMPLATE_SUCCESS,
  BACKUP_TEMPLATE_ERROR,
  GET_ROLE_SEARCH_OBJECT,
  GET_ROLE_SEARCH_OBJECT_SUCCESS,
  GET_ROLE_SEARCH_OBJECT_FAILURE,
  SEARCH_PEOPLE,
  SEARCH_PEOPLE_SUCCESS,
  SEARCH_PEOPLE_FAILURE,
  CLEAR_ROLE_SEARCH,
  GET_FILTERED_TIERS_LIST_SUCCESS,
  GET_FILTERED_TIERS_LIST_ERROR,
  CLEAR_FILTERED_TIERS,
  CLEAR_SHORTLISTED,
  CLEAR_SHORTLISTED_SUCCESS,
  UPDATE_SHORTLISTED_STATUS,
  UPDATE_SHORTLISTED_STATUS_SUCCESS,
  UPDATE_SHORTLISTED_STATUS_ERROR,
  CONFIRM_INVITE,
  CONFIRM_INVITE_SUCCESS,
  CONFIRM_INVITE_ERROR,
  REJECT_INVITE,
  REJECT_INVITE_SUCCESS,
  REJECT_INVITE_ERROR,
  UNSUBSCRIBE,
  UNSUBSCRIBE_SUCCESS,
  UNSUBSCRIBE_ERROR,
  WAITLIST_INVITE,
  WAITLIST_INVITE_SUCCESS,
  WAITLIST_INVITE_ERROR
} = actionTypes.tiers;

export const getShortlisted = (payload) => {
  return {
    type: GET_SHORTLISTED,
    payload
  };
};

export const getShortlistedSuccess = (response) => {
  return {
    type: GET_SHORTLISTED_SUCCESS,
    response
  };
};

export const getShortlistedError = (response) => {
  return {
    type: GET_SHORTLISTED_ERROR,
    response
  };
};

export const updateShortlisted = (payload) => {
  return {
    type: UPDATE_SHORTLISTED,
    payload
  };
};

export const addToShortlisted = (response) => {
  return {
    type: ADD_TO_SHORTLISTED,
    response
  };
};

export const updateShortlistedSuccess = (response) => {
  return {
    type: UPDATE_SHORTLISTED_SUCCESS,
    response
  };
};

export const updateShortlistedError = (response) => {
  return {
    type: UPDATE_SHORTLISTED_ERROR,
    response
  };
};

export const removeShortlisted = (payload) => {
  return {
    type: REMOVE_SHORTLISTED,
    payload
  };
};

export const removeShortlistedSuccess = (response) => {
  return {
    type: REMOVE_SHORTLISTED_SUCCESS,
    response
  };
};

export const sendInvite = (payload) => {
  return {
    type: SEND_INVITE,
    payload
  };
};

export const sendInviteSuccess = (response) => {
  return {
    type: SEND_INVITE_SUCCESS,
    response
  };
};

export const sendInviteError = (response) => {
  return {
    type: SEND_INVITE_ERROR,
    response
  };
};

export const generateTiers = (payload) => {
  return {
    type: GENERATE_TIERS,
    payload
  };
};

export const generateTiersSuccess = (response) => {
  return {
    type: GENERATE_TIERS_SUCCESS,
    response
  };
};

export const generateTiersError = (response) => {
  return {
    type: GENERATE_TIERS_ERROR,
    response
  };
};
  
export const getRoleData = (payload) => {
  return {
    type: GET_ROLE_DATA,
    payload
  };
};

export const getRoleDataSuccess = (response) => {
  return {
    type: GET_ROLE_DATA_SUCCESS,
    response
  };
};

export const getRoleDataError = (response) => {
  return {
    type: GET_ROLE_DATA_ERROR,
    response
  };
};

export const tiersJob = (payload) => {
  return {
    type: TIERS_JOB,
    payload
  };
};

export const tiersJobUpdating = (response) => {
  return {
    type: TIERS_JOB_UPDATING,
    response
  };
};

export const tiersJobSuccess = (response) => {
  return {
    type: TIERS_JOB_SUCCESS,
    response
  };
};

export const tiersJobError = (response) => {
  return {
    type: TIERS_JOB_ERROR,
    response
  };
};

export const tiersJobCancel = (response) => {
  return {
    type: TIERS_JOB_CANCEL,
    response
  };
};

export const confirmTemplate = (response) => {
  return {
    type: CONFIRM_TEMPLATE,
    response
  };
};

export const confirmTemplateSuccess = (response) => {
  return {
    type: CONFIRM_TEMPLATE_SUCCESS,
    response
  };
};

export const confirmTemplateError = (response) => {
  return {
    type: CONFIRM_TEMPLATE_ERROR,
    response
  };
};

export const backupTemplate = (response) => {
  return {
    type: BACKUP_TEMPLATE,
    response
  };
};

export const backupTemplateSuccess = (response) => {
  return {
    type: BACKUP_TEMPLATE_SUCCESS,
    response
  };
};

export const backupTemplateError = (response) => {
  return {
    type: BACKUP_TEMPLATE_ERROR,
    response
  };
};

export const getRoleSearchObject = (payload) => {
  return {
    type: GET_ROLE_SEARCH_OBJECT,
    payload
  };
};

export const getRoleSearchObjectSuccess = (response) => {
  return {
    type: GET_ROLE_SEARCH_OBJECT_SUCCESS,
    response
  };
};

export const getRoleSearchObjectFailure = (response) => {
  return {
    type: GET_ROLE_SEARCH_OBJECT_FAILURE,
    response
  };
};

export const searchPeople = (payload) => {
  return {
    type: SEARCH_PEOPLE,
    payload
  };
};

export const searchPeopleSuccess = (response) => {
  return {
    type: SEARCH_PEOPLE_SUCCESS,
    response
  };
};

export const searchPeopleFailure = (response) => {
  return {
    type: SEARCH_PEOPLE_FAILURE,
    response
  };
};

export const clearRoleSearch = (response) => {
  return {
    type: CLEAR_ROLE_SEARCH,
    response
  };
};

export const getFilteredTiersListSuccess = (response) => {
  return {
    type: GET_FILTERED_TIERS_LIST_SUCCESS,
    response
  };
};

export const getFilteredTiersListError = (response) => {
  return {
    type: GET_FILTERED_TIERS_LIST_ERROR,
    response
  };
};

export const clearFilteredTiers = (response) => {
  return {
    type: CLEAR_FILTERED_TIERS,
    response
  };
};
  
export const clearShortlisted = (payload) => {
  return {
    type: CLEAR_SHORTLISTED,
    payload
  };
};

export const clearShortlistedSuccess = (response) => {
  return {
    type: CLEAR_SHORTLISTED_SUCCESS,
    response
  };
};

export const updateShortlistedStatus = (payload) => {
  return {
    type: UPDATE_SHORTLISTED_STATUS,
    payload
  };
};

export const updateShortlistedStatusSuccess = (response) => {
  return {
    type: UPDATE_SHORTLISTED_STATUS_SUCCESS,
    response
  };
};

export const updateShortlistedStatusError = (response) => {
  return {
    type: UPDATE_SHORTLISTED_STATUS_ERROR,
    response
  };
};

export const confirmInvite = (payload) => {
  return {
    type: CONFIRM_INVITE,
    payload
  };
};

export const confirmInviteSuccess = (response) => {
  return {
    type: CONFIRM_INVITE_SUCCESS,
    response
  };
};

export const confirmInviteError = (response) => {
  return {
    type: CONFIRM_INVITE_ERROR,
    response
  };
};

export const waitlistInvite = (payload) => {
  return {
    type: WAITLIST_INVITE,
    payload
  };
};

export const waitlistInviteSuccess = (response) => {
  return {
    type: WAITLIST_INVITE_SUCCESS,
    response
  };
};

export const waitlistInviteError = (response) => {
  return {
    type: WAITLIST_INVITE_ERROR,
    response
  };
};

export const rejectInvite = (payload) => {
  return {
    type: REJECT_INVITE,
    payload
  };
};

export const rejectInviteSuccess = (response) => {
  return {
    type: REJECT_INVITE_SUCCESS,
    response
  };
};

export const rejectInviteError = (response) => {
  return {
    type: REJECT_INVITE_ERROR,
    response
  };
};

export const unsubscribe = (payload) => {
  return {
    type: UNSUBSCRIBE,
    payload
  };
};

export const unsubscribeSuccess = (response) => {
  return {
    type: UNSUBSCRIBE_SUCCESS,
    response
  };
};

export const unsubscribeError = (response) => {
  return {
    type: UNSUBSCRIBE_ERROR,
    response
  };
};
